import { Component } from '@angular/core';

@Component({
  selector: 'app-product-batch-serial-stock',
  standalone: false,
  
  templateUrl: './product-batch-serial-stock.component.html',
  styles: ``
})
export class ProductBatchSerialStockComponent {

}
